/* src/app/private/components/features/delete-feature/delete-feature.component.scss */
/*# sourceMappingURL=delete-feature.component.css.map */
